import { render, staticRenderFns } from "./VeeValidateErrorMessage.vue?vue&type=template&id=3b58b937&"
import script from "./VeeValidateErrorMessage.vue?vue&type=script&lang=js&"
export * from "./VeeValidateErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports